import type { ReactNode } from "react";

export type RunStatus =
  | "draft"
  | "queued"
  | "active"
  | "succeeded"
  | "failed"
  | "canceled"
  | "expired";

function RunStatusIcon({ status }: { status: RunStatus }) {
  return (
    <span
      className={`ui-run-status__dot ui-run-status__dot--${status}`}
      aria-hidden="true"
    />
  );
}

export function RunStatusTag({
  status,
  children,
  className,
}: {
  status: RunStatus;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={["ui-run-status", `ui-run-status--${status}`, className]
        .filter(Boolean)
        .join(" ")}
    >
      <RunStatusIcon status={status} />
      <span>{children}</span>
    </span>
  );
}
